import { track } from 'shared/Tracking';

export function goToPublicJobs() {
    let url = `${window.location.origin}/public/jobs/`;
    window.open(url, '_self');
}
export function goToPartialSignup() {
    let url = `${window.location.origin}/providers/signup/`;
    window.open(url, '_self');
}
